export default __webpack_public_path__ + "static/media/IndustrialApplicationsCardImg9.1afd90a0.png";